.card {
  background: var(--bg-panel);
  border-radius: var(--r-16);
  box-shadow: 0 10px 32px rgba(21, 23, 26, 0.14);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 16px;
  color: var(--success-text);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.dotOpen {
  background: var(--success);
}
.dotClosed {
  background: var(--danger);
}
.status:has(.dotClosed) {
  color: var(--danger);
}

.progressBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.progressTrack {
  height: 12px;
  border-radius: var(--r-pill);
  background: var(--border-2);
  overflow: hidden;
}

.progressFill {
  height: 100%;
  background: var(--accent);
  border-radius: var(--r-pill);
}

.progressLabel {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-variant-numeric: tabular-nums;
}
.progressLabel span {
  color: var(--text-muted);
}

.dates {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--border-2);
}

.dateRow {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-2);
  font-size: 15px;
}
.dateRow:last-child {
  border-bottom: none;
}
.dateRow span {
  color: var(--text-muted);
}
.dateRow strong {
  color: var(--accent-text-hover);
}

.tiers {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  text-align: center;
}

.tier {
  background: var(--bg-page);
  border-radius: var(--r-8);
  padding: 8px 4px;
}
.tier:first-child {
  background: var(--bg-accent-tint-2);
}

.tierLabel {
  font-size: 11px;
  color: var(--text-muted);
}

.tierValue {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 20px;
}

/* "Your entry" - Desktop.dc.html's itemized list, ported literally (label + border-separated
   rows, each with a name/detail pair on the left and a paid/unpaid pill on the right). */
.entryList {
  display: flex;
  flex-direction: column;
}

.entryListLabel {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
  padding-bottom: 2px;
}

.entryRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 9px 0;
  border-bottom: 1px solid var(--border-2);
}
.entryRow:last-child {
  border-bottom: none;
}

.entryRowMain {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.entryName {
  font-weight: 600;
  font-size: 15px;
}

.entryDetail {
  font-size: 13px;
  color: var(--text-muted);
}

.entryBadge {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: var(--r-pill);
}
.entryBadgePaid {
  background: var(--success-tint-bg);
  color: var(--success-text);
}
.entryBadgeUnpaid {
  background: var(--danger-tint-bg);
  color: var(--danger);
}

.priceLine {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-top: 4px;
}

.priceLabel {
  font-size: 15px;
  color: var(--text-muted);
}

.priceTotal {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 30px;
  font-variant-numeric: tabular-nums;
}

.signupBtn {
  height: 52px;
  width: 100%;
  border: none;
  border-radius: var(--r-12);
  background: var(--accent-strong);
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .signupBtn doubles as an <a> (Sign up / Go to checkout) and a <button> - the <a> case needs
   this: global.css's `a:hover { color: var(--accent-text-hover) }` has higher specificity than
   `.signupBtn` alone, so without it hover swaps the button's text to a dark brown instead of
   just darkening the button like the legacy checkout.cfm button does. */
.signupBtn:hover {
  filter: brightness(0.92);
  color: #fff;
}

.signupBtnDisabled {
  background: var(--border-2);
  color: var(--text-muted);
}
